<template>
  <section class="return-home" aria-labelledby="return-home-title">
    <div class="return-hero">
      <div class="return-hero__icon" aria-hidden="true">
        <img src="/img/icons/icon_192.png" alt="">
      </div>

      <div class="return-hero__content">
        <div class="return-eyebrow">Your campus is waiting</div>
        <h1 id="return-home-title">Welcome back!</h1>
        <p>Pick up your story, check in with your sisters, and see what changed while you were away.</p>
        <router-link class="pink-button return-play-button" :to="{name: 'SororityWarsHomeBroadcast'}">
          Play Sorority Wars
        </router-link>
      </div>

      <div class="return-hero__stamp" aria-hidden="true">
        <strong>Ready</strong>
        <span>for your next move</span>
      </div>
    </div>

    <nav class="return-shortcuts" aria-label="Quick game links">
      <div class="return-shortcuts__intro">
        <div class="return-eyebrow">Jump back in</div>
        <strong>Where are you headed?</strong>
      </div>

      <router-link :to="{name: 'SororityWarsHomeBroadcast'}">
        <span class="return-shortcut__number">01</span>
        <span><strong>Home feed</strong><small>Catch up with everyone</small></span>
      </router-link>
      <router-link :to="{name: 'SororityWarsFightBosses'}">
        <span class="return-shortcut__number">02</span>
        <span><strong>Boss battles</strong><small>Join the latest fight</small></span>
      </router-link>
      <router-link :to="{name: 'SororityGlamAccessories'}">
        <span class="return-shortcut__number">03</span>
        <span><strong>Wardrobe</strong><small>Style your next look</small></span>
      </router-link>
      <router-link :to="{name: 'SororityWarsSocialize'}">
        <span class="return-shortcut__number">04</span>
        <span><strong>Socialize</strong><small>Spend energy and earn rewards</small></span>
      </router-link>
    </nav>

    <div class="return-app-note">
      <div>
        <strong>Take Sorority Wars with you</strong>
        <span>Install the app for quick access and clear update alerts.</span>
      </div>
      <router-link class="blue-button return-app-button" :to="{name: 'Download'}">View app options</router-link>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LoggedIn'
}
</script>

<style scoped>
.return-home,
.return-home * {
  box-sizing: border-box;
}

.return-home {
  width: 100%;
  padding: 5px;
  color: #000;
  text-align: left;
}

.return-hero {
  position: relative;
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr) 155px;
  align-items: center;
  gap: 22px;
  min-height: 245px;
  overflow: hidden;
  padding: 26px 30px;
  background: #fff;
  border: 2px solid #e84063;
  border-radius: 12px;
}

.return-hero__icon {
  padding: 7px;
  background: #d1ebf1;
  border: 2px solid #238cbd;
  border-radius: 22px;
  box-shadow: 6px 6px 0 #ffccd7;
  transform: rotate(-2deg);
}

.return-hero__icon img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 15px;
}

.return-hero__content {
  min-width: 0;
}

.return-eyebrow {
  color: #0b5aa8;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.return-hero h1 {
  margin: 6px 0 8px;
  color: #145c89;
  font-size: clamp(28px, 4.5vw, 46px);
  font-weight: 800;
  letter-spacing: -0.035em;
  line-height: 1.04;
}

.return-hero h1 span {
  color: #ad1f51;
  overflow-wrap: anywhere;
}

.return-hero__content p {
  max-width: 570px;
  color: #333;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.5;
}

.return-play-button {
  width: fit-content;
  min-width: 210px;
  min-height: 46px;
  margin-top: 15px;
  padding: 9px 18px;
  text-align: center;
}

.return-hero__stamp {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 135px;
  height: 135px;
  padding: 12px;
  color: #fff;
  background: #145c89;
  border: 5px double #fff;
  border-radius: 50%;
  box-shadow: 0 0 0 2px #238cbd;
  text-align: center;
  transform: rotate(5deg);
}

.return-hero__stamp strong {
  font-size: 18px;
  text-transform: uppercase;
}

.return-hero__stamp span {
  margin-top: 2px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.3;
  text-transform: uppercase;
}

.return-shortcuts {
  display: grid;
  grid-template-columns: 1.15fr repeat(4, minmax(0, 1fr));
  gap: 5px;
  margin-top: 5px;
  padding: 8px;
  background: #145c89;
  border: 1px solid #238cbd;
  border-radius: 8px;
}

.return-shortcuts__intro {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 8px;
  color: #fff;
}

.return-shortcuts__intro .return-eyebrow {
  color: #ffccd7;
}

.return-shortcuts .return-shortcuts__intro strong {
  margin-top: 4px;
  color: #fff;
  font-size: 13px;
}

.return-shortcuts > a {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  min-width: 0;
  min-height: 78px;
  padding: 9px;
  background: #fff;
  border: 1px solid #d1ebf1;
  border-radius: 6px;
  transition: border-color 180ms ease, transform 180ms ease;
}

.return-shortcuts > a:hover,
.return-shortcuts > a:focus-visible {
  border-color: #e84063;
  transform: translateY(-1px);
}

.return-shortcut__number {
  flex: 0 0 auto;
  color: #e84063;
  font-size: 12px;
  font-weight: 800;
}

.return-shortcuts a > span:last-child,
.return-shortcuts strong,
.return-shortcuts small {
  display: block;
  min-width: 0;
}

.return-shortcuts strong {
  color: #0b5aa8;
  font-size: 11px;
}

.return-shortcuts small {
  margin-top: 3px;
  color: #333;
  font-size: 11px;
  line-height: 1.35;
}

.return-app-note {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 5px;
  padding: 9px 10px;
  background: #fff;
  border: 1px solid #238cbd;
  border-radius: 6px;
}

.return-app-note strong,
.return-app-note span {
  display: block;
}

.return-app-note strong {
  color: #0b5aa8;
  font-size: 12px;
}

.return-app-note span {
  margin-top: 2px;
  font-size: 12px;
}

.return-app-button {
  flex: 0 0 auto;
  min-height: 38px;
  padding: 7px 12px;
  text-align: center;
}

@media only screen and (max-width: 900px) {
  .return-hero {
    grid-template-columns: 150px minmax(0, 1fr);
  }

  .return-hero__stamp {
    display: none;
  }

  .return-shortcuts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .return-shortcuts__intro {
    grid-column: 1 / -1;
  }
}

@media only screen and (max-width: 560px) {
  .return-hero {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 22px 16px 28px;
    text-align: center;
  }

  .return-hero__icon {
    width: 125px;
    margin: 0 auto;
    border-radius: 17px;
    box-shadow: 4px 4px 0 #ffccd7;
  }

  .return-hero__icon img {
    border-radius: 11px;
  }

  .return-play-button {
    width: 100%;
  }

  .return-shortcuts {
    grid-template-columns: 1fr;
  }

  .return-shortcuts__intro {
    grid-column: auto;
  }

  .return-shortcuts > a {
    min-height: 64px;
  }

  .return-app-note {
    align-items: stretch;
    flex-direction: column;
    text-align: center;
  }

  .return-app-button {
    width: 100%;
  }
}
</style>
